export class ExportOperationsProposalModel {
  startDate: string;
  endDate: string;
  institution: string;
  serviceContract: string;
  cpfCnpj: string;
  technologyGroup: string;
  logicNumber: string;
}
